import React, { useState } from 'react';
import useIntl from 'react-intl/src/components/useIntl';
import { Accordion } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import {
  useCustomFieldDefinitions,
  useDeleteCustomField,
} from 'src/hooks/useCustomFields';
import { CustomFieldModal } from './CustomFieldModal';
import { runWithConfirmation } from 'src/utils/useful_functions';
import { errorToast } from 'src/api';
import { PanelHeading } from 'src/components/PanelHeading';
import messages from 'src/messages';
import { CustomFieldCategorySection } from './customFields/CustomFieldCategorySection';
import { CATEGORIES } from './customFields/fieldDefinitions';
import './CustomFieldsPanel.module.css';

type ModalState = {
  category: string;
  existingField: any | null;
};

export function CustomFieldsPanel() {
  const { formatMessage } = useIntl();
  const projectId = useSelector((state: any) => state.mainFrame.projectId);
  const permissionWrite = useSelector(
    (state: any) => state.mainFrame.permissionWrite
  );
  const { data: allDefs = {} } = useCustomFieldDefinitions(projectId);
  const deleteMutation = useDeleteCustomField(projectId);
  const [modalState, setModalState] = useState<ModalState | null>(null);

  const confirmDelete = (category: string, field: any) => {
    runWithConfirmation({
      header: formatMessage(messages.customFieldDeleteHeader),
      message: formatMessage(messages.customFieldDeleteMessage, {
        name: field.name,
      }),
      onConfirm: async () => {
        try {
          await deleteMutation.mutateAsync({ category, fieldId: field.id });
        } catch (e: any) {
          errorToast(
            e?.message || formatMessage(messages.customFieldDeleteFailed)
          );
        }
      },
    });
  };

  if (!projectId) {
    return null;
  }

  return (
    <div className="network-site-panel">
      <PanelHeading title={formatMessage(messages.customFields)} />
      <div className="main-panel custom-fields-panel-body">
        <Accordion exclusive={false} fluid className="project-details-panels">
          {CATEGORIES.map(({ key, label }) => (
            <CustomFieldCategorySection
              key={key}
              category={key}
              label={label}
              fields={allDefs[key] ?? []}
              permissionWrite={permissionWrite}
              onCreate={() =>
                setModalState({ category: key, existingField: null })
              }
              onEdit={(field) =>
                setModalState({ category: key, existingField: field })
              }
              onDelete={(field) => confirmDelete(key, field)}
            />
          ))}
        </Accordion>

        {modalState && (
          <CustomFieldModal
            projectId={projectId}
            category={modalState.category}
            existingField={modalState.existingField}
            onClose={() => setModalState(null)}
          />
        )}
      </div>
    </div>
  );
}

export default CustomFieldsPanel;
